import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.typed-array.sort.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import './media/diffReview.css';
import * as nls from '../../../nls.js';
import * as dom from '../../../base/browser/dom.js';
import { createFastDomNode } from '../../../base/browser/fastDomNode.js';
import { ActionBar } from '../../../base/browser/ui/actionbar/actionbar.js';
import { DomScrollableElement } from '../../../base/browser/ui/scrollbar/scrollableElement.js';
import { Action } from '../../../base/common/actions.js';
import { Disposable } from '../../../base/common/lifecycle.js';
import { Configuration } from '../config/configuration.js';
import { EditorAction, registerEditorAction } from '../editorExtensions.js';
import { ICodeEditorService } from '../services/codeEditorService.js';
import { EditorFontLigatures } from '../../common/config/editorOptions.js';
import { LineTokens } from '../../common/core/lineTokens.js';
import { Position } from '../../common/core/position.js';
import { editorLineNumbers } from '../../common/view/editorColorRegistry.js';
import { RenderLineInput, renderViewLine2 as renderViewLine } from '../../common/viewLayout/viewLineRenderer.js';
import { ViewLineRenderingData } from '../../common/viewModel/viewModel.js';
import { ContextKeyExpr } from '../../../platform/contextkey/common/contextkey.js';
import { scrollbarShadow } from '../../../platform/theme/common/colorRegistry.js';
import { registerThemingParticipant } from '../../../platform/theme/common/themeService.js';
import { registerIcon, Codicon } from '../../../base/common/codicons.js';
var DIFF_LINES_PADDING = 3;

var DiffEntry = /*#__PURE__*/function () {
  function DiffEntry(originalLineStart, originalLineEnd, modifiedLineStart, modifiedLineEnd) {
    _classCallCheck(this, DiffEntry);

    this.originalLineStart = originalLineStart;
    this.originalLineEnd = originalLineEnd;
    this.modifiedLineStart = modifiedLineStart;
    this.modifiedLineEnd = modifiedLineEnd;
  }

  _createClass(DiffEntry, [{
    key: "getType",
    value: function getType() {
      if (this.originalLineStart === 0) {
        return 1
        /* Insert */
        ;
      }

      if (this.modifiedLineStart === 0) {
        return 2
        /* Delete */
        ;
      }

      return 0
      /* Equal */
      ;
    }
  }]);

  return DiffEntry;
}();

var Diff = function Diff(entries) {
  _classCallCheck(this, Diff);

  this.entries = entries;
};

var diffReviewInsertIcon = registerIcon('diff-review-insert', Codicon.add);
var diffReviewRemoveIcon = registerIcon('diff-review-remove', Codicon.remove);
var diffReviewCloseIcon = registerIcon('diff-review-close', Codicon.close);
export var DiffReview = /*#__PURE__*/function (_Disposable) {
  _inherits(DiffReview, _Disposable);

  var _super = _createSuper(DiffReview);

  function DiffReview(diffEditor) {
    var _this;

    _classCallCheck(this, DiffReview);

    _this = _super.call(this);
    _this._width = 0;
    _this._diffEditor = diffEditor;
    _this._isVisible = false;
    _this.shadow = createFastDomNode(document.createElement('div'));

    _this.shadow.setClassName('diff-review-shadow');

    _this.actionBarContainer = createFastDomNode(document.createElement('div'));

    _this.actionBarContainer.setClassName('diff-review-actions');

    _this._actionBar = _this._register(new ActionBar(_this.actionBarContainer.domNode));

    _this._actionBar.push(new Action('diffreview.close', nls.localize('label.close', "Close"), 'close-diff-review ' + diffReviewCloseIcon.classNames, true, function () {
      _this.hide();

      return Promise.resolve(null);
    }), {
      label: false,
      icon: true
    });

    _this.domNode = createFastDomNode(document.createElement('div'));

    _this.domNode.setClassName('diff-review monaco-editor-background');

    _this._content = createFastDomNode(document.createElement('div'));

    _this._content.setClassName('diff-review-content');

    _this._content.setAttribute('role', 'code');

    _this.scrollbar = _this._register(new DomScrollableElement(_this._content.domNode, {}));

    _this.domNode.domNode.appendChild(_this.scrollbar.getDomNode());

    _this._register(diffEditor.onDidUpdateDiff(function () {
      if (!_this._isVisible) {
        return;
      }

      _this._diffs = _this._compute();

      _this._render();
    }));

    _this._register(diffEditor.getModifiedEditor().onDidChangeCursorPosition(function () {
      if (!_this._isVisible) {
        return;
      }

      _this._render();
    }));

    _this._register(dom.addStandardDisposableListener(_this.domNode.domNode, 'click', function (e) {
      e.preventDefault();
      var row = dom.findParentWithClass(e.target, 'diff-review-row');

      if (row) {
        _this._goToRow(row);
      }
    }));

    _this._register(dom.addStandardDisposableListener(_this.domNode.domNode, 'keydown', function (e) {
      if (e.equals(18
      /* DownArrow */
      ) || e.equals(2048
      /* CtrlCmd */
      | 18
      /* DownArrow */
      ) || e.equals(512
      /* Alt */
      | 18
      /* DownArrow */
      )) {
        e.preventDefault();

        _this._goToRow(_this._getNextRow());
      }

      if (e.equals(16
      /* UpArrow */
      ) || e.equals(2048
      /* CtrlCmd */
      | 16
      /* UpArrow */
      ) || e.equals(512
      /* Alt */
      | 16
      /* UpArrow */
      )) {
        e.preventDefault();

        _this._goToRow(_this._getPrevRow());
      }

      if (e.equals(9
      /* Escape */
      ) || e.equals(2048
      /* CtrlCmd */
      | 9
      /* Escape */
      ) || e.equals(512
      /* Alt */
      | 9
      /* Escape */
      ) || e.equals(1024
      /* Shift */
      | 9
      /* Escape */
      )) {
        e.preventDefault();

        _this.hide();
      }

      if (e.equals(10
      /* Space */
      ) || e.equals(3
      /* Enter */
      )) {
        e.preventDefault();

        _this.accept();
      }
    }));

    _this._diffs = [];
    _this._currentDiff = null;
    return _this;
  }

  _createClass(DiffReview, [{
    key: "prev",
    value: function prev() {
      var index = 0;

      if (!this._isVisible) {
        this._diffs = this._compute();
      }

      if (this._isVisible) {
        var currentIndex = -1;

        for (var i = 0, len = this._diffs.length; i < len; i++) {
          if (this._diffs[i] === this._currentDiff) {
            currentIndex = i;
            break;
          }
        }

        index = this._diffs.length + currentIndex - 1;
      } else {
        index = this._findDiffIndex(this._diffEditor.getPosition());
      }

      if (this._diffs.length === 0) {
        // Nothing to do
        return;
      }

      index = index % this._diffs.length;
      var entries = this._diffs[index].entries;

      this._diffEditor.setPosition(new Position(entries[0].modifiedLineStart, 1));

      this._diffEditor.setSelection({
        startColumn: 1,
        startLineNumber: entries[0].modifiedLineStart,
        endColumn: 1073741824
        /* MAX_SAFE_SMALL_INTEGER */
        ,
        endLineNumber: entries[entries.length - 1].modifiedLineEnd
      });

      this._isVisible = true;

      this._diffEditor.doLayout();

      this._render();

      this._goToRow(this._getNextRow());
    }
  }, {
    key: "next",
    value: function next() {
      var index = 0;

      if (!this._isVisible) {
        this._diffs = this._compute();
      }

      if (this._isVisible) {
        var currentIndex = -1;

        for (var i = 0, len = this._diffs.length; i < len; i++) {
          if (this._diffs[i] === this._currentDiff) {
            currentIndex = i;
            break;
          }
        }

        index = currentIndex + 1;
      } else {
        index = this._findDiffIndex(this._diffEditor.getPosition());
      }

      if (this._diffs.length === 0) {
        // Nothing to do
        return;
      }

      index = index % this._diffs.length;
      var entries = this._diffs[index].entries;

      this._diffEditor.setPosition(new Position(entries[0].modifiedLineStart, 1));

      this._diffEditor.setSelection({
        startColumn: 1,
        startLineNumber: entries[0].modifiedLineStart,
        endColumn: 1073741824
        /* MAX_SAFE_SMALL_INTEGER */
        ,
        endLineNumber: entries[entries.length - 1].modifiedLineEnd
      });

      this._isVisible = true;

      this._diffEditor.doLayout();

      this._render();

      this._goToRow(this._getNextRow());
    }
  }, {
    key: "accept",
    value: function accept() {
      var jumpToLineNumber = -1;

      var current = this._getCurrentFocusedRow();

      if (current) {
        var lineNumber = parseInt(current.getAttribute('data-line'), 10);

        if (!isNaN(lineNumber)) {
          jumpToLineNumber = lineNumber;
        }
      }

      this.hide();

      if (jumpToLineNumber !== -1) {
        this._diffEditor.setPosition(new Position(jumpToLineNumber, 1));

        this._diffEditor.revealPosition(new Position(jumpToLineNumber, 1), 1
        /* Immediate */
        );
      }
    }
  }, {
    key: "hide",
    value: function hide() {
      this._isVisible = false;

      this._diffEditor.updateOptions({
        readOnly: false
      });

      this._diffEditor.focus();

      this._diffEditor.doLayout();

      this._render();
    }
  }, {
    key: "_getPrevRow",
    value: function _getPrevRow() {
      var current = this._getCurrentFocusedRow();

      if (!current) {
        return this._getFirstRow();
      }

      if (current.previousElementSibling) {
        return current.previousElementSibling;
      }

      return current;
    }
  }, {
    key: "_getNextRow",
    value: function _getNextRow() {
      var current = this._getCurrentFocusedRow();

      if (!current) {
        return this._getFirstRow();
      }

      if (current.nextElementSibling) {
        return current.nextElementSibling;
      }

      return current;
    }
  }, {
    key: "_getFirstRow",
    value: function _getFirstRow() {
      return this.domNode.domNode.querySelector('.diff-review-row');
    }
  }, {
    key: "_getCurrentFocusedRow",
    value: function _getCurrentFocusedRow() {
      var result = document.activeElement;

      if (result && /diff-review-row/.test(result.className)) {
        return result;
      }

      return null;
    }
  }, {
    key: "_goToRow",
    value: function _goToRow(row) {
      var prev = this._getCurrentFocusedRow();

      row.tabIndex = 0;
      row.focus();

      if (prev && prev !== row) {
        prev.tabIndex = -1;
      }

      this.scrollbar.scanDomNode();
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      return this._isVisible;
    }
  }, {
    key: "layout",
    value: function layout(top, width, height) {
      this._width = width;
      this.shadow.setTop(top - 6);
      this.shadow.setWidth(width);
      this.shadow.setHeight(this._isVisible ? 6 : 0);
      this.domNode.setTop(top);
      this.domNode.setWidth(width);
      this.domNode.setHeight(height);

      this._content.setHeight(height);

      this._content.setWidth(width);

      if (this._isVisible) {
        this.actionBarContainer.setAttribute('aria-hidden', 'false');
        this.actionBarContainer.setDisplay('block');
      } else {
        this.actionBarContainer.setAttribute('aria-hidden', 'true');
        this.actionBarContainer.setDisplay('none');
      }
    }
  }, {
    key: "_compute",
    value: function _compute() {
      var lineChanges = this._diffEditor.getLineChanges();

      if (!lineChanges || lineChanges.length === 0) {
        return [];
      }

      var originalModel = this._diffEditor.getOriginalEditor().getModel();

      var modifiedModel = this._diffEditor.getModifiedEditor().getModel();

      if (!originalModel || !modifiedModel) {
        return [];
      }

      return DiffReview._mergeAdjacent(lineChanges, originalModel.getLineCount(), modifiedModel.getLineCount());
    }
  }, {
    key: "_findDiffIndex",
    value: function _findDiffIndex(pos) {
      var lineNumber = pos.lineNumber;

      for (var i = 0, len = this._diffs.length; i < len; i++) {
        var diff = this._diffs[i].entries;
        var lastModifiedLine = diff[diff.length - 1].modifiedLineEnd;

        if (lineNumber <= lastModifiedLine) {
          return i;
        }
      }

      return 0;
    }
  }, {
    key: "_render",
    value: function _render() {
      var originalOptions = this._diffEditor.getOriginalEditor().getOptions();

      var modifiedOptions = this._diffEditor.getModifiedEditor().getOptions();

      var originalModel = this._diffEditor.getOriginalEditor().getModel();

      var modifiedModel = this._diffEditor.getModifiedEditor().getModel();

      var originalModelOpts = originalModel.getOptions();
      var modifiedModelOpts = modifiedModel.getOptions();

      if (!this._isVisible || !originalModel || !modifiedModel) {
        dom.clearNode(this._content.domNode);
        this._currentDiff = null;
        this.scrollbar.scanDomNode();
        return;
      }

      this._diffEditor.updateOptions({
        readOnly: true
      });

      var diffIndex = this._findDiffIndex(this._diffEditor.getPosition());

      if (this._diffs[diffIndex] === this._currentDiff) {
        return;
      }

      this._currentDiff = this._diffs[diffIndex];
      var diffs = this._diffs[diffIndex].entries;
      var container = document.createElement('div');
      container.className = 'diff-review-table';
      container.setAttribute('role', 'list');
      container.setAttribute('aria-label', 'Difference review. Use "Stage | Unstage | Revert Selected Ranges" commands');
      Configuration.applyFontInfoSlow(container, modifiedOptions.get(36
      /* fontInfo */
      ));
      var minOriginalLine = 0;
      var maxOriginalLine = 0;
      var minModifiedLine = 0;
      var maxModifiedLine = 0;

      for (var i = 0, len = diffs.length; i < len; i++) {
        var diffEntry = diffs[i];
        var originalLineStart = diffEntry.originalLineStart;
        var originalLineEnd = diffEntry.originalLineEnd;
        var modifiedLineStart = diffEntry.modifiedLineStart;
        var modifiedLineEnd = diffEntry.modifiedLineEnd;

        if (originalLineStart !== 0 && (minOriginalLine === 0 || originalLineStart < minOriginalLine)) {
          minOriginalLine = originalLineStart;
        }

        if (originalLineEnd !== 0 && (maxOriginalLine === 0 || originalLineEnd > maxOriginalLine)) {
          maxOriginalLine = originalLineEnd;
        }

        if (modifiedLineStart !== 0 && (minModifiedLine === 0 || modifiedLineStart < minModifiedLine)) {
          minModifiedLine = modifiedLineStart;
        }

        if (modifiedLineEnd !== 0 && (maxModifiedLine === 0 || modifiedLineEnd > maxModifiedLine)) {
          maxModifiedLine = modifiedLineEnd;
        }
      }

      var header = document.createElement('div');
      header.className = 'diff-review-row';
      var cell = document.createElement('div');
      cell.className = 'diff-review-cell diff-review-summary';
      var originalChangedLinesCnt = maxOriginalLine - minOriginalLine + 1;
      var modifiedChangedLinesCnt = maxModifiedLine - minModifiedLine + 1;
      cell.appendChild(document.createTextNode("".concat(diffIndex + 1, "/").concat(this._diffs.length, ": @@ -").concat(minOriginalLine, ",").concat(originalChangedLinesCnt, " +").concat(minModifiedLine, ",").concat(modifiedChangedLinesCnt, " @@")));
      header.setAttribute('data-line', String(minModifiedLine));

      var getAriaLines = function getAriaLines(lines) {
        if (lines === 0) {
          return nls.localize('no_lines_changed', "no lines changed");
        } else if (lines === 1) {
          return nls.localize('one_line_changed', "1 line changed");
        } else {
          return nls.localize('more_lines_changed', "{0} lines changed", lines);
        }
      };

      var originalChangedLinesCntAria = getAriaLines(originalChangedLinesCnt);
      var modifiedChangedLinesCntAria = getAriaLines(modifiedChangedLinesCnt);
      header.setAttribute('aria-label', nls.localize({
        key: 'header',
        comment: ['This is the ARIA label for a git diff header.', 'A git diff header looks like this: @@ -154,12 +159,39 @@.', 'That encodes that at original line 154 (which is now line 159), 12 lines were removed/changed with 39 lines.', 'Variables 0 and 1 refer to the diff index out of total number of diffs.', 'Variables 2 and 4 will be numbers (a line number).', 'Variables 3 and 5 will be "no lines changed", "1 line changed" or "X lines changed", localized separately.']
      }, "Difference {0} of {1}: original line {2}, {3}, modified line {4}, {5}", diffIndex + 1, this._diffs.length, minOriginalLine, originalChangedLinesCntAria, minModifiedLine, modifiedChangedLinesCntAria));
      header.appendChild(cell); // @@ -504,7 +517,7 @@

      header.setAttribute('role', 'listitem');
      container.appendChild(header);
      var lineHeight = modifiedOptions.get(51
      /* lineHeight */
      );
      var modLine = minModifiedLine;

      for (var _i = 0, _len = diffs.length; _i < _len; _i++) {
        var _diffEntry = diffs[_i];

        DiffReview._renderSection(container, _diffEntry, modLine, lineHeight, this._width, originalOptions, originalModel, originalModelOpts, modifiedOptions, modifiedModel, modifiedModelOpts);

        if (_diffEntry.modifiedLineStart !== 0) {
          modLine = _diffEntry.modifiedLineEnd;
        }
      }

      dom.clearNode(this._content.domNode);

      this._content.domNode.appendChild(container);

      this.scrollbar.scanDomNode();
    }
  }], [{
    key: "_mergeAdjacent",
    value: function _mergeAdjacent(lineChanges, originalLineCount, modifiedLineCount) {
      if (!lineChanges || lineChanges.length === 0) {
        return [];
      }

      var diffs = [],
          diffsLength = 0;

      for (var i = 0, len = lineChanges.length; i < len; i++) {
        var lineChange = lineChanges[i];
        var originalStart = lineChange.originalStartLineNumber;
        var originalEnd = lineChange.originalEndLineNumber;
        var modifiedStart = lineChange.modifiedStartLineNumber;
        var modifiedEnd = lineChange.modifiedEndLineNumber;
        var _r = [],
            _rLength = 0; // Emit before anchors

        {
          var originalEqualAbove = originalEnd === 0 ? originalStart : originalStart - 1;
          var modifiedEqualAbove = modifiedEnd === 0 ? modifiedStart : modifiedStart - 1; // Make sure we don't step into the previous diff

          var minOriginal = 1;
          var minModified = 1;

          if (i > 0) {
            var prevLineChange = lineChanges[i - 1];

            if (prevLineChange.originalEndLineNumber === 0) {
              minOriginal = prevLineChange.originalStartLineNumber + 1;
            } else {
              minOriginal = prevLineChange.originalEndLineNumber + 1;
            }

            if (prevLineChange.modifiedEndLineNumber === 0) {
              minModified = prevLineChange.modifiedStartLineNumber + 1;
            } else {
              minModified = prevLineChange.modifiedEndLineNumber + 1;
            }
          }

          var fromOriginal = originalEqualAbove - DIFF_LINES_PADDING + 1;
          var fromModified = modifiedEqualAbove - DIFF_LINES_PADDING + 1;

          if (fromOriginal < minOriginal) {
            var delta = minOriginal - fromOriginal;
            fromOriginal = fromOriginal + delta;
            fromModified = fromModified + delta;
          }

          if (fromModified < minModified) {
            var _delta = minModified - fromModified;

            fromOriginal = fromOriginal + _delta;
            fromModified = fromModified + _delta;
          }

          _r[_rLength++] = new DiffEntry(fromOriginal, originalEqualAbove, fromModified, modifiedEqualAbove);
        } // Emit deleted lines

        {
          if (originalEnd !== 0) {
            _r[_rLength++] = new DiffEntry(originalStart, originalEnd, 0, 0);
          }
        } // Emit inserted lines

        {
          if (modifiedEnd !== 0) {
            _r[_rLength++] = new DiffEntry(0, 0, modifiedStart, modifiedEnd);
          }
        } // Emit after anchors

        {
          var originalEqualBelow = originalEnd === 0 ? originalStart + 1 : originalEnd + 1;
          var modifiedEqualBelow = modifiedEnd === 0 ? modifiedStart + 1 : modifiedEnd + 1; // Make sure we don't step into the next diff

          var maxOriginal = originalLineCount;
          var maxModified = modifiedLineCount;

          if (i + 1 < len) {
            var nextLineChange = lineChanges[i + 1];

            if (nextLineChange.originalEndLineNumber === 0) {
              maxOriginal = nextLineChange.originalStartLineNumber;
            } else {
              maxOriginal = nextLineChange.originalStartLineNumber - 1;
            }

            if (nextLineChange.modifiedEndLineNumber === 0) {
              maxModified = nextLineChange.modifiedStartLineNumber;
            } else {
              maxModified = nextLineChange.modifiedStartLineNumber - 1;
            }
          }

          var toOriginal = originalEqualBelow + DIFF_LINES_PADDING - 1;
          var toModified = modifiedEqualBelow + DIFF_LINES_PADDING - 1;

          if (toOriginal > maxOriginal) {
            var _delta2 = maxOriginal - toOriginal;

            toOriginal = toOriginal + _delta2;
            toModified = toModified + _delta2;
          }

          if (toModified > maxModified) {
            var _delta3 = maxModified - toModified;

            toOriginal = toOriginal + _delta3;
            toModified = toModified + _delta3;
          }

          _r[_rLength++] = new DiffEntry(originalEqualBelow, toOriginal, modifiedEqualBelow, toModified);
        }
        diffs[diffsLength++] = new Diff(_r);
      } // Merge adjacent diffs


      var curr = diffs[0].entries;
      var r = [],
          rLength = 0;

      for (var _i2 = 1, _len2 = diffs.length; _i2 < _len2; _i2++) {
        var thisDiff = diffs[_i2].entries;
        var currLast = curr[curr.length - 1];
        var thisFirst = thisDiff[0];

        if (currLast.getType() === 0
        /* Equal */
        && thisFirst.getType() === 0
        /* Equal */
        && thisFirst.originalLineStart <= currLast.originalLineEnd) {
          // We are dealing with equal lines that overlap
          curr[curr.length - 1] = new DiffEntry(currLast.originalLineStart, thisFirst.originalLineEnd, currLast.modifiedLineStart, thisFirst.modifiedLineEnd);
          curr = curr.concat(thisDiff.slice(1));
          continue;
        }

        r[rLength++] = new Diff(curr);
        curr = thisDiff;
      }

      r[rLength++] = new Diff(curr);
      return r;
    }
  }, {
    key: "_renderSection",
    value: function _renderSection(dest, diffEntry, modLine, lineHeight, width, originalOptions, originalModel, originalModelOpts, modifiedOptions, modifiedModel, modifiedModelOpts) {
      var type = diffEntry.getType();
      var rowClassName = 'diff-review-row';
      var lineNumbersExtraClassName = '';
      var spacerClassName = 'diff-review-spacer';
      var spacerIcon = null;

      switch (type) {
        case 1
        /* Insert */
        :
          rowClassName = 'diff-review-row line-insert';
          lineNumbersExtraClassName = ' char-insert';
          spacerIcon = diffReviewInsertIcon;
          break;

        case 2
        /* Delete */
        :
          rowClassName = 'diff-review-row line-delete';
          lineNumbersExtraClassName = ' char-delete';
          spacerIcon = diffReviewRemoveIcon;
          break;
      }

      var originalLineStart = diffEntry.originalLineStart;
      var originalLineEnd = diffEntry.originalLineEnd;
      var modifiedLineStart = diffEntry.modifiedLineStart;
      var modifiedLineEnd = diffEntry.modifiedLineEnd;
      var cnt = Math.max(modifiedLineEnd - modifiedLineStart, originalLineEnd - originalLineStart);
      var originalLayoutInfo = originalOptions.get(117
      /* layoutInfo */
      );
      var originalLineNumbersWidth = originalLayoutInfo.glyphMarginWidth + originalLayoutInfo.lineNumbersWidth;
      var modifiedLayoutInfo = modifiedOptions.get(117
      /* layoutInfo */
      );
      var modifiedLineNumbersWidth = 10 + modifiedLayoutInfo.glyphMarginWidth + modifiedLayoutInfo.lineNumbersWidth;

      for (var i = 0; i <= cnt; i++) {
        var originalLine = originalLineStart === 0 ? 0 : originalLineStart + i;
        var modifiedLine = modifiedLineStart === 0 ? 0 : modifiedLineStart + i;
        var row = document.createElement('div');
        row.style.minWidth = width + 'px';
        row.className = rowClassName;
        row.setAttribute('role', 'listitem');

        if (modifiedLine !== 0) {
          modLine = modifiedLine;
        }

        row.setAttribute('data-line', String(modLine));
        var cell = document.createElement('div');
        cell.className = 'diff-review-cell';
        cell.style.height = "".concat(lineHeight, "px");
        row.appendChild(cell);
        var originalLineNumber = document.createElement('span');
        originalLineNumber.style.width = originalLineNumbersWidth + 'px';
        originalLineNumber.style.minWidth = originalLineNumbersWidth + 'px';
        originalLineNumber.className = 'diff-review-line-number' + lineNumbersExtraClassName;

        if (originalLine !== 0) {
          originalLineNumber.appendChild(document.createTextNode(String(originalLine)));
        } else {
          originalLineNumber.innerText = "\xA0";
        }

        cell.appendChild(originalLineNumber);
        var modifiedLineNumber = document.createElement('span');
        modifiedLineNumber.style.width = modifiedLineNumbersWidth + 'px';
        modifiedLineNumber.style.minWidth = modifiedLineNumbersWidth + 'px';
        modifiedLineNumber.style.paddingRight = '10px';
        modifiedLineNumber.className = 'diff-review-line-number' + lineNumbersExtraClassName;

        if (modifiedLine !== 0) {
          modifiedLineNumber.appendChild(document.createTextNode(String(modifiedLine)));
        } else {
          modifiedLineNumber.innerText = "\xA0";
        }

        cell.appendChild(modifiedLineNumber);
        var spacer = document.createElement('span');
        spacer.className = spacerClassName;

        if (spacerIcon) {
          var spacerCodicon = document.createElement('span');
          spacerCodicon.className = spacerIcon.classNames;
          spacerCodicon.innerText = "\xA0\xA0";
          spacer.appendChild(spacerCodicon);
        } else {
          spacer.innerText = "\xA0\xA0";
        }

        cell.appendChild(spacer);
        var lineContent = void 0;

        if (modifiedLine !== 0) {
          cell.insertAdjacentHTML('beforeend', this._renderLine(modifiedModel, modifiedOptions, modifiedModelOpts.tabSize, modifiedLine));
          lineContent = modifiedModel.getLineContent(modifiedLine);
        } else {
          cell.insertAdjacentHTML('beforeend', this._renderLine(originalModel, originalOptions, originalModelOpts.tabSize, originalLine));
          lineContent = originalModel.getLineContent(originalLine);
        }

        if (lineContent.length === 0) {
          lineContent = nls.localize('blankLine', "blank");
        }

        var ariaLabel = '';

        switch (type) {
          case 0
          /* Equal */
          :
            if (originalLine === modifiedLine) {
              ariaLabel = nls.localize({
                key: 'unchangedLine',
                comment: ['The placholders are contents of the line and should not be translated.']
              }, "{0} unchanged line {1}", lineContent, originalLine);
            } else {
              ariaLabel = nls.localize('equalLine', "{0} original line {1} modified line {2}", lineContent, originalLine, modifiedLine);
            }

            break;

          case 1
          /* Insert */
          :
            ariaLabel = nls.localize('insertLine', "+ {0} modified line {1}", lineContent, modifiedLine);
            break;

          case 2
          /* Delete */
          :
            ariaLabel = nls.localize('deleteLine', "- {0} original line {1}", lineContent, originalLine);
            break;
        }

        row.setAttribute('aria-label', ariaLabel);
        dest.appendChild(row);
      }
    }
  }, {
    key: "_renderLine",
    value: function _renderLine(model, options, tabSize, lineNumber) {
      var lineContent = model.getLineContent(lineNumber);
      var fontInfo = options.get(36
      /* fontInfo */
      );
      var defaultMetadata = (0
      /* None */
      << 11
      /* FONT_STYLE_OFFSET */
      | 1
      /* DefaultForeground */
      << 14
      /* FOREGROUND_OFFSET */
      | 2
      /* DefaultBackground */
      << 23
      /* BACKGROUND_OFFSET */
      ) >>> 0;
      var tokens = new Uint32Array(2);
      tokens[0] = lineContent.length;
      tokens[1] = defaultMetadata;
      var lineTokens = new LineTokens(tokens, lineContent);
      var isBasicASCII = ViewLineRenderingData.isBasicASCII(lineContent, model.mightContainNonBasicASCII());
      var containsRTL = ViewLineRenderingData.containsRTL(lineContent, isBasicASCII, model.mightContainRTL());
      var r = renderViewLine(new RenderLineInput(fontInfo.isMonospace && !options.get(24
      /* disableMonospaceOptimizations */
      ), fontInfo.canUseHalfwidthRightwardsArrow, lineContent, false, isBasicASCII, containsRTL, 0, lineTokens, [], tabSize, 0, fontInfo.spaceWidth, fontInfo.middotWidth, fontInfo.wsmiddotWidth, options.get(95
      /* stopRenderingLineAfter */
      ), options.get(80
      /* renderWhitespace */
      ), options.get(74
      /* renderControlCharacters */
      ), options.get(37
      /* fontLigatures */
      ) !== EditorFontLigatures.OFF, null));
      return r.html;
    }
  }]);

  return DiffReview;
}(Disposable); // theming

registerThemingParticipant(function (theme, collector) {
  var lineNumbers = theme.getColor(editorLineNumbers);

  if (lineNumbers) {
    collector.addRule(".monaco-diff-editor .diff-review-line-number { color: ".concat(lineNumbers, "; }"));
  }

  var shadow = theme.getColor(scrollbarShadow);

  if (shadow) {
    collector.addRule(".monaco-diff-editor .diff-review-shadow { box-shadow: ".concat(shadow, " 0 -6px 6px -6px inset; }"));
  }
});

var DiffReviewNext = /*#__PURE__*/function (_EditorAction) {
  _inherits(DiffReviewNext, _EditorAction);

  var _super2 = _createSuper(DiffReviewNext);

  function DiffReviewNext() {
    _classCallCheck(this, DiffReviewNext);

    return _super2.call(this, {
      id: 'editor.action.diffReview.next',
      label: nls.localize('editor.action.diffReview.next', "Go to Next Difference"),
      alias: 'Go to Next Difference',
      precondition: ContextKeyExpr.has('isInDiffEditor'),
      kbOpts: {
        kbExpr: null,
        primary: 65
        /* F7 */
        ,
        weight: 100
        /* EditorContrib */

      }
    });
  }

  _createClass(DiffReviewNext, [{
    key: "run",
    value: function run(accessor, editor) {
      var diffEditor = findFocusedDiffEditor(accessor);

      if (diffEditor) {
        diffEditor.diffReviewNext();
      }
    }
  }]);

  return DiffReviewNext;
}(EditorAction);

var DiffReviewPrev = /*#__PURE__*/function (_EditorAction2) {
  _inherits(DiffReviewPrev, _EditorAction2);

  var _super3 = _createSuper(DiffReviewPrev);

  function DiffReviewPrev() {
    _classCallCheck(this, DiffReviewPrev);

    return _super3.call(this, {
      id: 'editor.action.diffReview.prev',
      label: nls.localize('editor.action.diffReview.prev', "Go to Previous Difference"),
      alias: 'Go to Previous Difference',
      precondition: ContextKeyExpr.has('isInDiffEditor'),
      kbOpts: {
        kbExpr: null,
        primary: 1024
        /* Shift */
        | 65
        /* F7 */
        ,
        weight: 100
        /* EditorContrib */

      }
    });
  }

  _createClass(DiffReviewPrev, [{
    key: "run",
    value: function run(accessor, editor) {
      var diffEditor = findFocusedDiffEditor(accessor);

      if (diffEditor) {
        diffEditor.diffReviewPrev();
      }
    }
  }]);

  return DiffReviewPrev;
}(EditorAction);

function findFocusedDiffEditor(accessor) {
  var codeEditorService = accessor.get(ICodeEditorService);
  var diffEditors = codeEditorService.listDiffEditors();
  var activeCodeEditor = codeEditorService.getActiveCodeEditor();

  if (!activeCodeEditor) {
    return null;
  }

  for (var i = 0, len = diffEditors.length; i < len; i++) {
    var diffEditor = diffEditors[i];

    if (diffEditor.getModifiedEditor().getId() === activeCodeEditor.getId() || diffEditor.getOriginalEditor().getId() === activeCodeEditor.getId()) {
      return diffEditor;
    }
  }

  return null;
}

registerEditorAction(DiffReviewNext);
registerEditorAction(DiffReviewPrev);